(function ($) {
	"use strict";
	let blockWheelsPortfolio = {
		initAll: function () {

			const elementList = document.querySelectorAll('.wp-block-blockwheels-portfolios');

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Portfolio
			[...elementList].forEach((portfolio) => {
				$(portfolio).find('.filter-container').isotope({
					// options
					itemSelector: '.portfolio-items',
					layoutMode: 'fitRows'
				});
				let $gallery = $(portfolio).find('.filter-container').isotope({
				// options
				});
				// filter items on button click
				$(portfolio).find('.filtering').on( 'click', 'li', function() {
					let filterValue = $(this).attr('data-filter');
					$gallery.isotope({ filter: filterValue });
				});
				$(portfolio).find('.filtering').on( 'click', 'li', function() {
					$(this).addClass('active').siblings().removeClass('active');
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockWheelsPortfolio.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockWheelsPortfolio.init);
	} else {
		// The DOM has already been loaded.
		blockWheelsPortfolio.init();
	}
})(jQuery);